interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  align?: 'left' | 'center';
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  className = '',
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';

  return (
    <div className={`${alignment} max-w-2xl ${className}`}>
      {eyebrow && (
        <span className="text-primary-600 text-[11px] font-semibold tracking-[0.2em] uppercase">
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 text-[28px] md:text-[38px] font-semibold text-foreground-900 leading-[1.12] tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-[15px] text-foreground-500 leading-relaxed font-light ${align === 'center' ? 'mx-auto' : ''}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}